import {
    BodyMediumRegular,
    Button,
    ButtonSize,
    ButtonVariant,
    YStack,
} from 'smoothie';

import {
    format,
    SHORT_READABLE_DATE_FORMAT,
} from '../../../../../common/utils/dateUtils';

interface RecurringTransferDateProps {
    onSubmit: (date?: Date) => void;
    date?: Date;
    onOpenStartDateSelector: () => void;
}

const RecurringTransferDate = ({
    onSubmit,
    date,
    onOpenStartDateSelector,
}: RecurringTransferDateProps) => {
    const hasStartDate = date != null;

    return (
        <YStack width="100%" gap={48}>
            {hasStartDate ? (
                <BodyMediumRegular textAlign="center">
                    {format(date, SHORT_READABLE_DATE_FORMAT)}
                </BodyMediumRegular>
            ) : (
                <BodyMediumRegular textAlign="center">
                    When would you like to start this recurring transfer?
                </BodyMediumRegular>
            )}
            <YStack gap={12}>
                <Button
                    variant={ButtonVariant.SECONDARY}
                    size={ButtonSize.LARGE}
                    text="Select a start date"
                    onPress={() => {
                        onOpenStartDateSelector();
                    }}
                />
                {date != null && (
                    <Button
                        variant={ButtonVariant.PRIMARY}
                        size={ButtonSize.LARGE}
                        text="Save"
                        onPress={() => {
                            onSubmit(date);
                        }}
                    />
                )}
            </YStack>
        </YStack>
    );
};

export default RecurringTransferDate;
